import { CUSTOMER_PERMISSION_CATALOG } from "@/domain/permissionCatalog";

const CUSTOMER_PERMISSIONS = CUSTOMER_PERMISSION_CATALOG;

const ALL_CUSTOMER_PERM_IDS = CUSTOMER_PERMISSION_CATALOG.map((p) => p.id);

const CUSTOMER_ROLE_GRANTS = {
  group_admin: ALL_CUSTOMER_PERM_IDS,
  company_admin: ALL_CUSTOMER_PERM_IDS.filter(
    (id) => id !== "customer.scope.all_companies",
  ),
  order_executive: [
    "customer.orders.read",
    "customer.orders.write",
    "customer.trips.read",
    "customer.scope.all_companies",
  ],
  planner: [
    "customer.orders.read",
    "customer.orders.write",
    "customer.trips.read",
  ],
  operations: [
    "customer.orders.read",
    "customer.trips.read",
    "customer.trips.write",
    "customer.pod.read",
    "customer.office.read",
  ],
  accountant: [
    "customer.finance.read",
    "customer.finance.write",
    "customer.office.read",
    "customer.scope.all_companies",
  ],
  driver: ["customer.trips.read", "customer.pod.read"],
  buyer: ["customer.orders.read", "customer.trips.read", "customer.pod.read"],
  seller: ["customer.orders.read"],
  port_member: ["customer.trips.read", "customer.pod.read"],
  workshop_manager: [
    "customer.workshop.read",
    "customer.workshop.write",
    "customer.trips.read",
  ],
};

function customerRoleHasPermission(roleId, permissionId) {
  const grants = CUSTOMER_ROLE_GRANTS[roleId] ?? [];
  return grants.includes(permissionId);
}

function permissionsForCustomerRole(roleId) {
  return CUSTOMER_ROLE_GRANTS[roleId] ?? [];
}

export {
  CUSTOMER_PERMISSIONS,
  CUSTOMER_ROLE_GRANTS,
  customerRoleHasPermission,
  permissionsForCustomerRole,
};
